export function QtyControl({ value, onChange }) {
  return (
    <input
      type="number"
      min="1"
      max="999"
      value={value}
      onChange={(e) => onChange(Math.max(1, parseInt(e.target.value || '1', 10)))}
      className="qty-input"
      style={{
        width: 56,
        textAlign: 'center',
        background: 'var(--bg-3)',
        border: '1px solid var(--line)',
        borderRadius: 6,
        color: 'var(--fg)',
        padding: '4px 6px',
      }}
    />
  );
}
